import React from 'react';
import styled from 'styled-components';
import Item, { Section, Content, Button } from './item';
import { offsets, fontSizes, colors } from '../../../styles';
import { addItem } from '../../../helpers/basket';

const Price = styled(Section)`
  font-size: ${fontSizes.sm};
  color: ${colors.black};
`;

const PizzaItem = ({ id, name, consistsOf, weight, diameter, price, pictureId }) => (
  <Item
    imgUrl={require(`../../../images/menu-pics/${pictureId}.png`)}
    imgAlt={`pizza-${id}`}
    isImgCircle
    name={name}
    id={id}
  >
    <Section>
      <b>Состав:</b>&nbsp;
      <span dangerouslySetInnerHTML={{__html:consistsOf}}/>
    </Section>
    <Section>
      <b>Диаметр</b>: {diameter} см
    </Section>
    <Section>
      <b>Вес</b>: {weight} гр
    </Section>
    <Price>
      <b>Цена</b>: {price} р
    </Price>
  </Item>
);

export default PizzaItem;
